import { CorporatePartAssignVendorFormData } from 'corporate/components';
import { PricingSourceType } from 'pricing/enums';
import { ICustomerQuotePart } from 'quotes/types';

export const mapQuotePartAssignVendorFormData = (
  quoteParts: ICustomerQuotePart[],
  data: CorporatePartAssignVendorFormData,
  isAlternateVersionEnabled = false
) => {
  const { vendorId, vendorName } = data;

  // Changing the vendor makes the BE refetch the line's externally sourced
  // pricing. A manually entered price has to survive that, so flag it per line
  // (a multi-line assign keeps each line's own override).
  const getAlternateData = (quotePart: ICustomerQuotePart) => ({
    accountsPayableId: data.accountsPayableId,
    ...(PricingSourceType.CUSTOM === quotePart?.priceSourceType ? { isPricingCustom: 1 } : {}),
  });

  return {
    quoteParts: quoteParts.map((quotePart) => ({
      id: quotePart.id,
      companyManufacturerId: vendorId,
      companyManufacturerName: vendorName,
      ...(isAlternateVersionEnabled ? getAlternateData(quotePart) : {}),
    })),
  };
};
